<template>
  <div class="page-container">
    <div class="body-content">
      <div class="index-container">
        <div class="action-buttons">
          <el-tooltip content="收藏" placement="right" v-show="!isImmersive">
            <el-button class="icon-button" v-if="paperActionTarget && paperActionTarget.status == '1'" icon="el-icon-star-on" @click="action(['0',3,1,paperActionTarget.targetId])"></el-button>
            <el-button class="icon-button" v-else icon="el-icon-star-off" @click="action(['1',3,1,paperActionTarget.targetId])"></el-button>
          </el-tooltip>
          <el-tooltip content="评论" placement="right" v-show="!isImmersive">
            <el-button class="icon-button" icon="el-icon-chat-line-round" @click="openQuestionComment"></el-button>
          </el-tooltip>
          <el-tooltip content="随手记" placement="right" v-show="!isImmersive">
            <el-button class="icon-button" icon="el-icon-edit-outline" @click="showNoteDrawer = true"></el-button>
          </el-tooltip>
          <el-tooltip content="沉浸模式" placement="right">
            <el-button class="icon-button" :icon="isImmersive ? 'el-icon-full-screen' : 'el-icon-rank'" @click="toggleImmersive"></el-button>
          </el-tooltip>
          <el-tooltip content="同屏对比" placement="right" v-show="!isImmersive">
            <el-button class="icon-button" :icon="isCompareMode ? 'el-icon-close' : 'el-icon-copy-document'" @click="toggleCompareMode"></el-button>
          </el-tooltip>
          <el-tooltip content="查看材料" placement="right" v-show="isCompareMode && !isImmersive">
            <el-button class="icon-button" icon="el-icon-document" @click="showMaterialDrawer = true"></el-button>
          </el-tooltip>
        </div>
        <div class="question-section" :class="{ 'full-width': isImmersive }">
          <div class="paper-header">
            <h2 class="paper-text">{{ paperTitle }}</h2>
          </div>
          <div class="question-tabs">
            <button v-for="(question, index) in questions" :key="index" class="tab-button"
              :class="{ active: currentQuestionIndex === question.questionIndex }" @click="setCurrentQuestion(question)">
              第{{ question.questionIndex }}题
            </button>
          </div>
          <div class="ql-editor" style="height: auto;padding: 0;">
            <div class="content-area">
              <div v-html="currentQuestion?.content"></div>
            </div>
          </div>

          <div class="answer-tabs">
            <button v-for="(answer, index) in answerTabs" :key="index" class="tab-button"
              :class="{ active: currentAnswerIndex === index }" @click="setCurrentAnswer(index)">
              <span>{{ answer.label }}</span>
            </button>
            <button class="add-answer-tab-action" @click="addAnswer">我要补充答案</button>
          </div>
          <div class="ql-editor" style="height: auto;padding: 0;">
            <div v-if="hasReferenceAnswers" class="content-area user-add-answers merged-user-add-answers">
              <div v-if="hasOfficialAnswers" class="reference-answer-list">
                <div v-for="(answer, index) in answers" :key="answer.answerId || index" class="user-add-answer-item">
                  <div class="answer-header">
                    <div class="answer-info">
                      <el-tag size="small" type="success" effect="plain" class="answer-source">{{ answer.source ? "某" + answer.source.slice(1) : '' }}</el-tag>
                    </div>
                    <div class="answer-actions">
                      <div class="action-item">
                        <el-button type="text" class="action-btn"
                          @click="action([answerActionSupportList.find(item => item.targetId === answer.answerId)?.status === '1' ? '0' : '1', 1, 3, answer.answerId])"
                          :class="{ active: answerActionSupportList.find(item => item.targetId === answer.answerId)?.status === '1' }">
                          <img :src="require('@/assets/images/support.png')" class="action-icon" v-if="answerActionSupportList.find(item => item.targetId === answer.answerId)?.status === '1'" />
                          <img :src="require('@/assets/images/un-support.png')" class="action-icon" v-else />
                          <span>{{ answerActionSupportList.find(item => item.targetId === answer.answerId)?.count || 0 }}</span>
                        </el-button>
                      </div>
                      <div class="action-item">
                        <el-button type="text" class="action-btn"
                          @click="action([answerActionAgainstList.find(item => item.targetId === answer.answerId)?.status === '1' ? '0' : '1', 2, 3, answer.answerId])"
                          :class="{ active: answerActionAgainstList.find(item => item.targetId === answer.answerId)?.status === '1' }">
                          <img :src="require('@/assets/images/against.png')" class="action-icon" v-if="answerActionAgainstList.find(item => item.targetId === answer.answerId)?.status === '1'" />
                          <img :src="require('@/assets/images/un-against.png')" class="action-icon" v-else />
                          <span>{{ answerActionAgainstList.find(item => item.targetId === answer.answerId)?.count || 0 }}</span>
                        </el-button>
                      </div>
                      <div class="action-item">
                        <el-tooltip content="评论" placement="top">
                          <el-button type="text" class="action-btn comment-btn" @click="openAnswerComment(3, answer.answerId)">
                            <img :src="require('@/assets/images/comment.svg')" class="action-icon comment-icon" />
                            <span>{{ answer.commentCount || 0 }}</span>
                          </el-button>
                        </el-tooltip>
                      </div>
                      <div class="action-item">
                        <el-tooltip :content="isAnswerReported(answer) ? '已举报' : '举报'" placement="top">
                          <el-button type="text" class="action-btn report-btn" :class="{ active: isAnswerReported(answer) }" @click="openReportModal(3, answer.answerId)">
                            <img :src="require(isAnswerReported(answer) ? '@/assets/images/action-report-active.svg' : '@/assets/images/action-report.svg')" class="action-icon report-icon" />
                          </el-button>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                  <div v-html="answer.content" class="answer-content no-copy"></div>
                </div>
              </div>
              <div v-if="hasUserAddAnswers && userAddAnswerShow">
                  <div v-for="(answer, index) in userAddAnswers" :key="answer.addId || index" class="user-add-answer-item">
                    <div class="answer-header">
                      <div class="answer-info">
                        <el-tag size="small" type="success" effect="plain" class="answer-source">{{ answer.source }}</el-tag>
                      </div>
                      <div class="answer-actions">
                        <div class="action-item">
                          <el-button type="text" class="action-btn"
                            @click="action([addActionSupportList.find(item => item.targetId === answer.addId)?.status === '1' ? '0' : '1', 1, 4, answer.addId])"
                            :class="{ active: addActionSupportList.find(item => item.targetId === answer.addId)?.status === '1' }">
                            <img :src="require('@/assets/images/support.png')" class="action-icon" v-if="addActionSupportList.find(item => item.targetId === answer.addId)?.status === '1'" />
                            <img :src="require('@/assets/images/un-support.png')" class="action-icon" v-else />
                            <span>{{ addActionSupportList.find(item => item.targetId === answer.addId)?.count || 0 }}</span>
                          </el-button>
                        </div>
                        <div class="action-item">
                          <el-button type="text" class="action-btn"
                            @click="action([addActionAgainstList.find(item => item.targetId === answer.addId)?.status === '1' ? '0' : '1', 2, 4, answer.addId])"
                            :class="{ active: addActionAgainstList.find(item => item.targetId === answer.addId)?.status === '1' }">
                            <img :src="require('@/assets/images/against.png')" class="action-icon" v-if="addActionAgainstList.find(item => item.targetId === answer.addId)?.status === '1'" />
                            <img :src="require('@/assets/images/un-against.png')" class="action-icon" v-else />
                            <span>{{ addActionAgainstList.find(item => item.targetId === answer.addId)?.count || 0 }}</span>
                          </el-button>
                        </div>
                        <div class="action-item">
                          <el-tooltip content="评论" placement="top">
                            <el-button type="text" class="action-btn comment-btn" @click="openAnswerComment(4, answer.addId)">
                              <img :src="require('@/assets/images/comment.svg')" class="action-icon comment-icon" />
                              <span>{{ answer.commentCount || 0 }}</span>
                            </el-button>
                          </el-tooltip>
                        </div>
                        <div class="action-item">
                          <el-tooltip :content="isAnswerReported(answer) ? '已举报' : '举报'" placement="top">
                            <el-button type="text" class="action-btn report-btn" :class="{ active: isAnswerReported(answer) }" @click="openReportModal(4, answer.addId)">
                              <img :src="require(isAnswerReported(answer) ? '@/assets/images/action-report-active.svg' : '@/assets/images/action-report.svg')" class="action-icon report-icon" />
                            </el-button>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                    <div v-html="answer.content" class="answer-content no-copy"></div>
                  </div>
              </div>
              <div v-if="hasUserAddAnswers && !userAddAnswerShow" class="no-permission">
                <img src="@/assets/images/no-permission.png" />
                <div class="desc">非会员无权限查看网友补充答案内容！</div>
              </div>
            </div>
            <div v-else class="content-area no-add-answer">暂无参考答案</div>
          </div>
          <div class="answer-actions">
          Tips:先输入答案，点击
          <button @click="compareOverlap" class="action-button" :disabled="comparingOverlap">
            {{ comparingOverlap ? '正在对比...' : '对比重合度' }}
          </button>
          根据对比情况，整理好答案后，再点击
          <button @click="submit('submit-user-answer')" class="action-button">上传至答案库</button>
        </div>
        <div class="answer-box">
          <quill-editor v-model="userAnswer" :options="editorOption" @change="onEditorChange($event)" ref="quillEditor" />
          <!-- 隐藏的文件上传输入框 -->
          <input
            type="file"
            ref="ocrFileInput"
            style="display: none"
            accept="image/*"
            @change="handleOcrImageUpload"
          />
          <div class="editor-footer">
            <span class="char-count">（{{ userAnswerContentLength }}字）</span>
          </div>
          <div class="answer-info">
            <span>此题已上传过 {{ userAnswerCount }} 次答案，</span>
            <a href="javascript:" @click="reviewAnswers" class="review-link">点此回顾</a>
          </div>
        </div>

        </div>
        <div class="materials-section" v-if="!isCompareMode && !isImmersive">
          <div class="materials-tabs-container">
            <div class="materials-tabs">
              <button v-for="(material, index) in materials" :key="index" class="tab-button"
                :class="{ active: currentMaterialIndex === material.materialIndex }"
                @click="setCurrentMaterial(material)">
                材料{{ material.materialIndex }}
              </button>
            </div>
            <div class="materials-content">
              <div class="ql-editor" style="height: auto; padding: 0;">
                <div class="content-area">
                  <div v-html="currentMaterial?.content"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 对比区域 -->
        <div class="compare-section" v-if="isCompareMode && !isImmersive">
          <div class="compare-header">
            <el-cascader
              v-model="selectedPaper"
              :options="regionPaperOptions"
              :props="{ lazy: true, lazyLoad: loadPaperOptions }"
              placeholder="请选择地区和试卷"
              @change="handlePaperChange"
              class="paper-select"
              clearable>
            </el-cascader>
            <el-tooltip content="查看材料" placement="top" v-if="comparePaper">
              <el-button class="material-icon-btn" icon="el-icon-document" circle @click="showCompareMaterialDrawer = true"></el-button>
            </el-tooltip>
          </div>

          <div v-if="comparePaper" class="compare-content">
            <div class="question-tabs">
              <button v-for="(question, index) in comparePaper.questions" :key="index" class="tab-button"
                :class="{ active: comparePaper.currentQuestionIndex === question.questionIndex }"
                @click="setCompareQuestionIndex(question.questionIndex)">
                第{{ question.questionIndex }}题
              </button>
            </div>

            <div class="ql-editor" style="height: auto;padding: 0;">
              <div class="content-area">
                <div v-html="currentCompareQuestion?.content"></div>
              </div>
            </div>

            <div class="answer-tabs">
              <button v-for="(answer, index) in answerTabs" :key="index" class="tab-button"
                :class="{ active: comparePaper.currentAnswerIndex === index }"
                @click="setCompareAnswerIndex(index)">
                <span>{{ answer.label }}</span>
              </button>
              <button class="add-answer-tab-action" @click="addAnswer">我要补充答案</button>
            </div>

            <div class="ql-editor" style="height: auto;padding: 0;">
              <div v-if="hasCompareReferenceAnswers" class="content-area user-add-answers merged-user-add-answers">
                <div v-if="hasCompareOfficialAnswers" class="reference-answer-list">
                  <div v-for="(answer, index) in comparePaper.answers" :key="answer.answerId || index" class="user-add-answer-item">
                    <div class="answer-header">
                      <div class="answer-info">
                        <el-tag size="small" type="success" effect="plain" class="answer-source">{{ answer.source ? "某" + answer.source.slice(1) : '' }}</el-tag>
                      </div>
                      <div class="answer-actions">
                        <div class="action-item">
                          <el-button type="text" class="action-btn"
                            @click="action([compareAnswerActionSupportList.find(item => item.targetId === answer.answerId)?.status === '1' ? '0' : '1', 1, 3, answer.answerId])"
                            :class="{ active: compareAnswerActionSupportList.find(item => item.targetId === answer.answerId)?.status === '1' }">
                            <img :src="require('@/assets/images/support.png')" class="action-icon" v-if="compareAnswerActionSupportList.find(item => item.targetId === answer.answerId)?.status === '1'" />
                            <img :src="require('@/assets/images/un-support.png')" class="action-icon" v-else />
                            <span>{{ compareAnswerActionSupportList.find(item => item.targetId === answer.answerId)?.count || 0 }}</span>
                          </el-button>
                        </div>
                        <div class="action-item">
                          <el-button type="text" class="action-btn"
                            @click="action([compareAnswerActionAgainstList.find(item => item.targetId === answer.answerId)?.status === '1' ? '0' : '1', 2, 3, answer.answerId])"
                            :class="{ active: compareAnswerActionAgainstList.find(item => item.targetId === answer.answerId)?.status === '1' }">
                            <img :src="require('@/assets/images/against.png')" class="action-icon" v-if="compareAnswerActionAgainstList.find(item => item.targetId === answer.answerId)?.status === '1'" />
                            <img :src="require('@/assets/images/un-against.png')" class="action-icon" v-else />
                            <span>{{ compareAnswerActionAgainstList.find(item => item.targetId === answer.answerId)?.count || 0 }}</span>
                          </el-button>
                        </div>
                        <div class="action-item">
                          <el-tooltip content="评论" placement="top">
                            <el-button type="text" class="action-btn comment-btn" @click="openAnswerComment(3, answer.answerId)">
                              <img :src="require('@/assets/images/comment.svg')" class="action-icon comment-icon" />
                              <span>{{ answer.commentCount || 0 }}</span>
                            </el-button>
                          </el-tooltip>
                        </div>
                        <div class="action-item">
                        <el-tooltip :content="isAnswerReported(answer) ? '已举报' : '举报'" placement="top">
                          <el-button type="text" class="action-btn report-btn" :class="{ active: isAnswerReported(answer) }" @click="openReportModal(3, answer.answerId)">
                            <img :src="require(isAnswerReported(answer) ? '@/assets/images/action-report-active.svg' : '@/assets/images/action-report.svg')" class="action-icon report-icon" />
                          </el-button>
                        </el-tooltip>
                        </div>
                      </div>
                    </div>
                    <div v-html="answer.content" class="answer-content no-copy"></div>
                  </div>
                </div>
                <div v-if="hasCompareUserAddAnswers && compareUserAddAnswerShow">
                    <div v-for="(answer, index) in compareUserAddAnswers" :key="answer.addId || index" class="user-add-answer-item">
                      <div class="answer-header">
                        <div class="answer-info">
                          <el-tag size="small" type="success" effect="plain" class="answer-source">{{ answer.source }}</el-tag>
                        </div>
                        <div class="answer-actions">
                          <div class="action-item">
                            <el-button type="text" class="action-btn"
                              @click="action([compareAddActionSupportList.find(item => item.targetId === answer.addId)?.status === '1' ? '0' : '1', 1, 4, answer.addId])"
                              :class="{ active: compareAddActionSupportList.find(item => item.targetId === answer.addId)?.status === '1' }">
                              <img :src="require('@/assets/images/support.png')" class="action-icon" v-if="compareAddActionSupportList.find(item => item.targetId === answer.addId)?.status === '1'" />
                              <img :src="require('@/assets/images/un-support.png')" class="action-icon" v-else />
                              <span>{{ compareAddActionSupportList.find(item => item.targetId === answer.addId)?.count || 0 }}</span>
                            </el-button>
                          </div>
                          <div class="action-item">
                            <el-button type="text" class="action-btn"
                              @click="action([compareAddActionAgainstList.find(item => item.targetId === answer.addId)?.status === '1' ? '0' : '1', 2, 4, answer.addId])"
                              :class="{ active: compareAddActionAgainstList.find(item => item.targetId === answer.addId)?.status === '1' }">
                              <img :src="require('@/assets/images/against.png')" class="action-icon" v-if="compareAddActionAgainstList.find(item => item.targetId === answer.addId)?.status === '1'" />
                              <img :src="require('@/assets/images/un-against.png')" class="action-icon" v-else />
                              <span>{{ compareAddActionAgainstList.find(item => item.targetId === answer.addId)?.count || 0 }}</span>
                            </el-button>
                          </div>
                          <div class="action-item">
                            <el-tooltip content="评论" placement="top">
                              <el-button type="text" class="action-btn comment-btn" @click="openAnswerComment(4, answer.addId)">
                                <img :src="require('@/assets/images/comment.svg')" class="action-icon comment-icon" />
                                <span>{{ answer.commentCount || 0 }}</span>
                              </el-button>
                            </el-tooltip>
                          </div>
                          <div class="action-item">
                            <el-tooltip :content="isAnswerReported(answer) ? '已举报' : '举报'" placement="top">
                              <el-button type="text" class="action-btn report-btn" :class="{ active: isAnswerReported(answer) }" @click="openReportModal(4, answer.addId)">
                                <img :src="require(isAnswerReported(answer) ? '@/assets/images/action-report-active.svg' : '@/assets/images/action-report.svg')" class="action-icon report-icon" />
                              </el-button>
                            </el-tooltip>
                          </div>
                        </div>
                      </div>
                      <div v-html="answer.content" class="answer-content no-copy"></div>
                    </div>
                </div>
                <div v-if="hasCompareUserAddAnswers && !compareUserAddAnswerShow" class="no-permission">
                  <img src="@/assets/images/no-permission.png" />
                  <div class="desc">非会员无权限查看网友补充答案内容！</div>
                </div>
              </div>
              <div v-else class="content-area no-add-answer">暂无参考答案</div>
            </div>
          </div>
          <div v-else class="compare-placeholder">
            <i class="el-icon-document-copy" style="font-size: 48px; color: #ddd;"></i>
            <p>请选择要对比的试卷</p>
          </div>
        </div>
      </div>
    </div>

    <el-drawer
      :title="commentDrawerTitle"
      :visible.sync="showCommentDrawer"
      direction="rtl"
      size="30%"
      :before-close="handleDrawerClose">
      <div class="comment-container">
        <div class="comment-list">
          <div v-for="(comment, index) in commentList" :key="index" class="comment-item">
            <div class="comment-header">
              <el-avatar :size="32" :src="comment.user?.avatar || defaultAvatar"></el-avatar>
              <span class="username">{{ $formatUserName(comment.user) }}</span>
              <span class="time">{{ formatTime(comment.createTime) }}</span>
              <el-button 
                v-if="comment.userId === $store.getters['user/getState'].userId"
                type="text" 
                class="delete-btn" 
                @click="deleteComment(comment.commentId)">
                <i class="el-icon-delete"></i>
              </el-button>
            </div>
            <div class="comment-content" v-html="comment.content || ''"></div>
          </div>
          <div v-if="commentList.length === 0" class="no-comment">
            {{ commentEmptyText }}
          </div>
        </div>
        <div class="comment-input">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入您的评论"
            v-model="commentContent"
            maxlength="500"
            show-word-limit>
          </el-input>
          <el-button type="primary" @click="submitComment" :disabled="!commentContent.trim()" style="background-color: #46B4B1; border-color: #46B4B1;">
            发表评论
          </el-button>
        </div>
      </div>
    </el-drawer>

    <el-drawer
      :title="`随手记 ${noteList.length}`"
      :visible.sync="showNoteDrawer"
      direction="rtl"
      size="30%"
      :before-close="handleNoteDrawerClose">
      <div class="comment-container">
        <div class="comment-list">
          <div v-for="(note, index) in noteList" :key="index" class="comment-item">
            <div class="note-header">
              <span class="time">{{ formatTime(note.createTime) }}</span>
              <el-button type="text" class="delete-btn" @click="deleteNote(note.noteId)">
                <i class="el-icon-delete"></i>
              </el-button>
            </div>
            <div class="note-content" v-html="note.content || ''"></div>
          </div>
          <div v-if="noteList.length === 0" class="no-comment">
            暂无笔记，快来记录第一条笔记吧~
          </div>
        </div>
        <div class="comment-input">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入您的笔记"
            v-model="noteContent"
            maxlength="500"
            show-word-limit>
          </el-input>
          <el-button type="primary" @click="submitNote" :disabled="!noteContent.trim()" style="background-color: #46B4B1; border-color: #46B4B1;">
            保存笔记
          </el-button>
        </div>
      </div>
    </el-drawer>

    <el-drawer
      :title="`我的答案 ${userAnswers.length}`"
      :visible.sync="showAnswerDrawer"
      direction="rtl"
      size="30%"
      :before-close="handleAnswerDrawerClose">
      <div class="comment-container">
        <div class="comment-list">
          <div v-for="(answer, index) in userAnswers" :key="index" class="comment-item">
            <div class="note-header">
              <span class="time">{{ formatTime(answer.createTime) }}</span>
              <el-button type="text" class="delete-btn" @click="deleteUserAnswer(answer.answerId)">
                <i class="el-icon-delete"></i>
              </el-button>
            </div>
            <div class="note-content" v-html="answer.content"></div>
          </div>
          <div v-if="userAnswers.length === 0" class="no-comment">
            暂无答案记录~
          </div>
        </div>
      </div>
    </el-drawer>

    <el-drawer
      title="材料"
      :visible.sync="showMaterialDrawer"
      direction="ltr"
      size="50%"
      :before-close="handleMaterialDrawerClose">
      <div class="material-container">
        <div class="materials-tabs">
          <button v-for="(material, index) in materials" :key="index" class="tab-button"
            :class="{ active: currentMaterialIndex === material.materialIndex }"
            @click="setCurrentMaterial(material)">
            材料{{ material.materialIndex }}
          </button>
        </div>
        <div class="materials-content">
          <div class="ql-editor" style="height: auto; padding: 20px;">
            <div class="content-area">
              <div v-html="currentMaterial?.content"></div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>

    <el-drawer
      title="对比试卷材料"
      :visible.sync="showCompareMaterialDrawer"
      direction="rtl"
      size="50%"
      :before-close="handleCompareMaterialDrawerClose">
      <div class="material-container">
        <div class="materials-tabs">
          <button v-for="(material, index) in comparePaper?.materials || []" :key="index" class="tab-button"
            :class="{ active: compareMaterialIndex === material.materialIndex }"
            @click="setCompareMaterial(material)">
            材料{{ material.materialIndex }}
          </button>
        </div>
        <div class="materials-content">
          <div class="ql-editor" style="height: auto; padding: 20px;">
            <div class="content-area">
              <div v-html="currentCompareMaterial?.content"></div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>

    <el-dialog
      title="举报答案"
      :visible.sync="showReportDialog"
      width="520px"
      append-to-body
      :close-on-click-modal="!reportSubmitting">
      <div class="report-dialog-tip">请选择举报原因，提交后后台可根据目标类型和目标ID定位处理。</div>
      <div class="report-tags">
        <button
          v-for="item in reportTypeOptions"
          :key="item.type"
          type="button"
          class="report-tag"
          :class="{ active: reportForm.type === item.type }"
          @click="selectReportType(item)">
          {{ item.name }}
        </button>
      </div>
      <el-input
        v-model="reportForm.content"
        type="textarea"
        :rows="4"
        maxlength="100"
        show-word-limit
        placeholder="补充说明（选填）" />
      <div slot="footer" class="dialog-footer">
        <el-button class="report-cancel-btn" @click="showReportDialog = false" :disabled="reportSubmitting">取消</el-button>
        <el-button class="report-submit-btn" type="primary" @click="submitReport" :loading="reportSubmitting">提交举报</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { getQuestionList, getMaterialList, getAnswerList, getUserAnswerList, getUserAddAnswerList, getPaperList, getUserCommentList, getUserNoteList, getTargetsActionStatus, insertUserAnswer, insertUserComment, insertUserNote, doAction, deleteUserComment, deleteUserNote, deleteUserAnswer, getOcr, insertBrowseRecord, insertReport, getReportType } from '@/api';
import { uploadMinioUrl } from '@/api';
import { adStatus, hasCopyPermission, hasSideComparePermission, showPermissionDeniedTip } from '@/utils/permissionUtils';
import discussCategory from '@/components/business/discuss/discussCategory.vue';
import { createOverlapWorkerTask, highlightHtmlByRanges } from '@/utils/filtrate';
import defaultAvatar from '@/assets/images/default-user.png';
import _ from 'lodash';

export default {
  name: 'ChineseLearningApp',
  components: {
    quillEditor,
    'discuss-category': discussCategory
  },
  data() {
    return {
      paperTitle: '',
      currentQuestionIndex: 1,
      currentMaterialIndex: 1,
      currentAnswerIndex: 0,
      questions: [],
      materials: [],
      answers: [],
      userAddAnswers: [],
      answerRequestSeq: 0,
      compareAnswerRequestSeq: 0,
      userAnswer: '',
      userAnswerContentLength: 0,
      loading: {
        submitComment: false,
        submitNote: false,
        submitAnswer: false,
        deleteComment: false,
        deleteNote: false,
        deleteAnswer: false,
        initial: false
      },
      editorOption: {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{ 'color': [] }],
            [{ 'align': [] }],
            ['clean']
          ]
        },
        placeholder: '请输入您的答案'
      },
      answerTabs: [
        { label: '答案', source: '答案' }
      ],
      addActionSupportList: [],
      addActionAgainstList: [],
      answerActionSupportList: [],
      answerActionAgainstList: [],
      compareAddActionSupportList: [], // 对比试卷网友补充答案点赞列表
      compareAddActionAgainstList: [], // 对比试卷网友补充答案点踩列表
      compareAnswerActionSupportList: [], // 对比试卷机构答案点赞列表
      compareAnswerActionAgainstList: [], // 对比试卷机构答案点踩列表
      paperActionTarget: null,
      isCollected: false,
      pageParams: {
        pageNum: 1,
        pageSize: 1000,
        paperId: '',
        questionId: '',
      },
      isCompareMode: false,
      selectedPaper: [],
      comparePaper: null,
      regionPaperOptions: [],
      showCommentDrawer: false,
      commentContent: '',
      commentList: [],
      commentParams: {
        pageNum: 1,
        pageSize: 1000,
        targetId: '',
        targetType: 2
      },
      commentTarget: {
        targetType: 2,
        targetId: '',
        mode: 'question'
      },
      defaultAvatar: defaultAvatar,
      showNoteDrawer: false,
      noteContent: '',
      noteList: [],
      showMaterialDrawer: false,
      showCompareMaterialDrawer: false,
      compareMaterialIndex: 1,
      isImmersive: false,
      userAnswerCount: 0,
      userAnswers: [],
      showAnswerDrawer: false,
      adState: true,
      answerShow: true,
      userAddAnswerShow: true,
      compareAnswerShow: true, // 对比试卷的机构答案权限
      compareUserAddAnswerShow: true, // 对比试卷的网友补充答案权限
      originalAnswers: [], // 保存原始机构答案，用于重置高亮
      originalUserAddAnswers: [], // 保存原始网友补充答案，用于重置高亮
      isHighlighted: false, // 标记是否已进行高亮对比
      comparingOverlap: false,
      overlapTask: null,
      overlapJobId: 0,
      uploadingOcr: false, // OCR上传状态
      showReportDialog: false,
      reportSubmitting: false,
      reportTarget: {
        targetType: null,
        targetId: null
      },
      reportForm: {
        type: null,
        reason: '',
        content: ''
      },
      reportTypeOptions: [
        { type: 101, name: '内容错漏' },
        { type: 103, name: '与题目无关' },
        { type: 104, name: '来源错误' },
        { type: 106, name: '其他原因' }
      ]
    }
  },
  computed: {
    currentQuestion() {
      return this.questions[this.currentQuestionIndex - 1];
    },
    currentMaterial() {
      return this.materials[this.currentMaterialIndex - 1];
    },
    hasOfficialAnswers() {
      return Array.isArray(this.answers) && this.answers.length > 0;
    },
    hasUserAddAnswers() {
      return Array.isArray(this.userAddAnswers) && this.userAddAnswers.length > 0;
    },
    hasReferenceAnswers() {
      return this.hasOfficialAnswers || this.hasUserAddAnswers;
    },
    hasCompareOfficialAnswers() {
      return !!(this.comparePaper && Array.isArray(this.comparePaper.answers) && this.comparePaper.answers.length > 0);
    },
    hasCompareUserAddAnswers() {
      return !!(this.comparePaper && Array.isArray(this.comparePaper.userAddAnswers) && this.comparePaper.userAddAnswers.length > 0);
    },
    hasCompareReferenceAnswers() {
      return this.hasCompareOfficialAnswers || this.hasCompareUserAddAnswers;
    },
    currentAnswer() {
      if (!this.answers || this.answers.length === 0) {
        return { content: '暂无答案数据', source: '参考答案' };
      }
      return this.answers[0];
    },
    areaList() {
      return this.$store.getters["category/getState"].areaCategoryList;
    },
    currentCompareAnswer() {
      if (!this.comparePaper || !this.comparePaper.answers || this.comparePaper.answers.length === 0) {
        return { content: '暂无答案数据', source: '参考答案' };
      }
      return this.comparePaper.answers[0];
    },
    compareUserAddAnswers() {
      if (!this.comparePaper || !this.comparePaper.userAddAnswers) return [];
      return this.comparePaper.userAddAnswers;
    },
    currentCompareQuestion() {
      if (!this.comparePaper || !this.comparePaper.questions) {
        return null;
      }
      return this.comparePaper.questions[this.comparePaper.currentQuestionIndex - 1];
    },
    currentCompareMaterial() {
      if (!this.comparePaper || !this.comparePaper.materials) {
        return null;
      }
      return this.comparePaper.materials.find(m => m.materialIndex === this.compareMaterialIndex);
    },
    canSubmitAnswer() {
      return this.userAnswer.trim().length > 0 && !this.loading.submitAnswer;
    },
    canSubmitComment() {
      return this.commentContent.trim().length > 0 && !this.loading.submitComment;
    },
    canSubmitNote() {
      return this.noteContent.trim().length > 0 && !this.loading.submitNote;
    },
    commentDrawerTitle() {
      const count = this.commentList.length;
      return `${this.commentTarget.mode === 'answer' ? '答案评论' : '评论'} ${count}`;
    },
    commentEmptyText() {
      return this.commentTarget.mode === 'answer' ? '暂无答案评论，快来发表第一条评论吧~' : '暂无评论，快来发表第一条评论吧~';
    },
    // 机构答案的点赞状态和数量
    currentAnswerSupport() {
      const support = this.answerActionSupportList.find(item => item.targetId === this.currentAnswer?.answerId);
      return {
        isActive: support?.status === '1',
        count: support?.count || 0
      };
    },

    // 机构答案的点踩状态和数量
    currentAnswerAgainst() {
      const against = this.answerActionAgainstList.find(item => item.targetId === this.currentAnswer?.answerId);
      return {
        isActive: against?.status === '1',
        count: against?.count || 0
      };
    },

    // 对比试卷机构答案的点赞状态和数量
    compareAnswerSupport() {
      const support = this.compareAnswerActionSupportList.find(item => item.targetId === this.currentCompareAnswer?.answerId);
      return {
        isActive: support?.status === '1',
        count: support?.count || 0
      };
    },

    // 对比试卷机构答案的点踩状态和数量
    compareAnswerAgainst() {
      const against = this.compareAnswerActionAgainstList.find(item => item.targetId === this.currentCompareAnswer?.answerId);
      return {
        isActive: against?.status === '1',
        count: against?.count || 0
      };
    }
  },
  created() {
    const routePaperId = this.$route.params.paperId;
    const normalizedPaperId = routePaperId == null ? '' : String(routePaperId).trim();
    if (!normalizedPaperId || ['undefined', 'null'].includes(normalizedPaperId.toLowerCase())) {
      this.$message.warning('试卷参数无效，请重新进入');
      this.$router.replace('/community/studyRoom/paper');
      return;
    }
    this.paperId = normalizedPaperId;
    this.currentQuestionIndex = this.$route.params.questionIndex ? this.$route.params.questionIndex : 1;
    this.loadInitialData();
    // 保存浏览记录
    this.saveViewHistory();
    // 获取地区列表
    if (this.areaList.length === 0) {
      this.$store.dispatch('category/GetAreaList');
    }
  },
  mounted() {
    // 添加全局复制事件监听
    document.addEventListener('copy', this.handleCopyEvent);

    this.checkAdStatus();

    // 等待编辑器初始化完成后添加OCR按钮
    this.$nextTick(() => {
      this.addOcrButtonToToolbar();
    });

    // 初始化地区选项
    this.initRegionOptions();
  },
  beforeDestroy() {
    // 移除全局复制事件监听
    document.removeEventListener('copy', this.handleCopyEvent);
    this.cancelOverlapComparison();
  },
  methods: {
    // 保存浏览记录
    async saveViewHistory() {
      try {
        const currentQuestion = this.currentQuestion;
        if (!currentQuestion) return;

        // 生成题目显示文本（第一题、第二题等）
        const generateQuestionOrder = (index) => {
          return `第${index}题`;
        };

        const data = {
          paperId: this.paperId,
          questionId: currentQuestion.questionId,
          questionIndex: this.currentQuestionIndex,        // 题目序号（数字）
          questionOrder: generateQuestionOrder(this.currentQuestionIndex) // 题目显示文本
        };

        // 调用API保存浏览记录
        const res = await insertBrowseRecord(data);
        if (res.code === 200) {
          console.log('浏览记录保存成功');
        } else {
          console.warn('浏览记录保存失败:', res.msg);
        }
      } catch (error) {
        console.error('保存浏览记录失败:', error);
      }
    },

    // 添加OCR按钮到工具栏
    addOcrButtonToToolbar() {
      // 等待DOM完全加载
      setTimeout(() => {
        const toolbar = document.querySelector('.ql-toolbar.ql-snow');
        if (toolbar) {
          // 创建OCR按钮容器
          const ocrButtonContainer = document.createElement('div');
          ocrButtonContainer.className = 'ql-formats';

          // 创建OCR按钮
          const ocrButton = document.createElement('button');
          ocrButton.className = 'ql-ocr';
          ocrButton.type = 'button';

          // 创建图标
          const ocrIcon = document.createElement('img');
          ocrIcon.src = require('@/assets/images/ocr.png');
          ocrIcon.alt = 'OCR';
          ocrIcon.style.cssText = `
            width: 18px;
            height: 18px;
            display: block;
          `;

          // 添加点击事件
          ocrButton.addEventListener('click', () => {
            this.triggerOcrUpload();
          });

          // 组装按钮
          ocrButton.appendChild(ocrIcon);
          ocrButtonContainer.appendChild(ocrButton);

          // 添加到工具栏最后面
          toolbar.appendChild(ocrButtonContainer);

          // 添加按钮样式
          ocrButton.style.cssText = `
            background: none;
            border: none;
            cursor: pointer;
            padding: 3px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 3px;
            transition: background-color 0.2s;
          `;

          // 添加悬停效果
          ocrButton.addEventListener('mouseenter', () => {
            ocrButton.style.backgroundColor = '#f0f0f0';
          });

          ocrButton.addEventListener('mouseleave', () => {
            ocrButton.style.backgroundColor = 'transparent';
          });
        }
      }, 500); // 延迟500ms确保编辑器完全初始化
    },

    // 触发OCR图片上传
    triggerOcrUpload() {
      console.log('OCR按钮被点击');
      if (this.$refs.ocrFileInput) {
        this.$refs.ocrFileInput.click();
      } else {
        console.error('无法找到文件输入框');
      }
    },

    // 处理OCR图片上传
    async handleOcrImageUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 检查文件类型
      if (!file.type.startsWith('image/')) {
        this.$message.error('请选择图片文件');
        return;
      }

      // 检查文件大小 (5MB限制)
      if (file.size > 5 * 1024 * 1024) {
        this.$message.error('图片大小不能超过5MB');
        return;
      }

      this.uploadingOcr = true;
      this.$message.info('正在上传图片并进行OCR识别...');

      try {
        // 1. 上传图片到MinIO
        const formData = new FormData();
        formData.append('file', file);

        const uploadResponse = await fetch(uploadMinioUrl, {
          method: 'POST',
          body: formData,
          headers: {
            'Authorization': 'Bearer ' + this.$store.getters['user/getState'].token
          }
        });

        const uploadResult = await uploadResponse.json();

        if (uploadResult && uploadResult.url) {
          const imgUrl = uploadResult.url;

          // 2. 调用OCR识别
          const ocrResponse = await getOcr({ imgUrl });

          if (ocrResponse.data && ocrResponse.data.items) {
            // 3. 处理OCR结果
            let recognizedText = '';
            for (let key in ocrResponse.data.items) {
              let item = ocrResponse.data.items[key];
              recognizedText = recognizedText.concat(item.text);
            }

            if (recognizedText.trim()) {
              // 4. 将识别结果插入到富文本编辑器
              this.insertOcrResult(recognizedText);
              this.$message.success('OCR识别完成，已插入到编辑器中');
            } else {
              this.$message.warning('未能识别到文字内容，请尝试更清晰的图片');
            }
          } else {
            this.$message.error('OCR识别失败，请重试');
          }
        } else {
          this.$message.error('图片上传失败，请重试');
        }
      } catch (error) {
        console.error('OCR处理失败:', error);
        this.$message.error('OCR处理失败，请重试');
      } finally {
        this.uploadingOcr = false;
        // 清空文件输入框
        event.target.value = '';
      }
    },

    // 将OCR结果插入到富文本编辑器
    insertOcrResult(text) {
      const quill = this.$refs.quillEditor?.quill;
      if (quill) {
        const index = quill.getSelection()?.index || quill.getLength();
        quill.insertText(index, text);
        quill.setSelection(index + text.length);
      }
    },

    // 广告权限检查
    checkAdStatus() {
      const versionInfo = this.$store.getters["user/getState"].versionInfo || {};
      this.adState = adStatus(versionInfo);
      this.userAddAnswerShow = !this.adState;
      this.compareUserAddAnswerShow = !this.adState;
    },
    isSameQuestionId(left, right) {
      return String(left || '') === String(right || '');
    },
    getQuestionIdByIndex(index) {
      const question = this.questions.find(item => String(item.questionIndex) === String(index));
      return question ? question.questionId : '';
    },
    isCurrentQuestionRequest(questionId, questionIndex) {
      return String(this.currentQuestionIndex) === String(questionIndex) &&
        this.isSameQuestionId(this.getQuestionIdByIndex(questionIndex), questionId);
    },
    isCurrentCompareQuestionRequest(questionId, questionIndex) {
      if (!this.comparePaper) return false;
      const question = this.comparePaper.questions.find(item => String(item.questionIndex) === String(questionIndex));
      return String(this.comparePaper.currentQuestionIndex) === String(questionIndex) &&
        this.isSameQuestionId(question && question.questionId, questionId);
    },
    filterAnswerRowsByQuestion(rows, questionId, questionIndex) {
      if (!Array.isArray(rows)) return [];
      if (!questionId && !questionIndex) return rows;
      return rows.filter(item => {
        const rowQuestionId = item.questionId ||
          (item.question && item.question.questionId) ||
          (item.questionInfo && item.questionInfo.questionId);
        if (rowQuestionId) {
          return this.isSameQuestionId(rowQuestionId, questionId);
        }
        const rowQuestionIndex = item.questionIndex ||
          (item.question && item.question.questionIndex) ||
          (item.questionInfo && item.questionInfo.questionIndex);
        return !rowQuestionIndex || String(rowQuestionIndex) === String(questionIndex);
      });
    },
    resetMainAnswerState() {
      this.cancelOverlapComparison();
      this.answers = [];
      this.userAddAnswers = [];
      this.answerActionSupportList = [];
      this.answerActionAgainstList = [];
      this.addActionSupportList = [];
      this.addActionAgainstList = [];
      this.currentAnswerIndex = 0;
      this.isHighlighted = false;
      this.originalAnswers = [];
      this.originalUserAddAnswers = [];
    },
    resetCompareAnswerState() {
      if (this.comparePaper) {
        this.comparePaper.answers = [];
        this.comparePaper.userAddAnswers = [];
        this.comparePaper.currentAnswerIndex = 0;
      }
      this.compareAnswerActionSupportList = [];
      this.compareAnswerActionAgainstList = [];
      this.compareAddActionSupportList = [];
      this.compareAddActionAgainstList = [];
    },
    async loadInitialData() {
      this.loading = {
        ...this.loading,
        initial: true
      };
      try {
        await Promise.all([
          this.getPaperList(this.paperId),
          this.getQuestionList(this.paperId),
          this.getMaterialList(this.paperId)
        ]);
      } catch (error) {
        console.error(error);
        this.$message.error('数据加载失败');
      } finally {
        this.loading = {
          ...this.loading,
          initial: false
        };
      }
    },
    async setCurrentQuestion(question) {
      this.currentQuestionIndex = question.questionIndex;
      this.resetMainAnswerState();

      // 使用 await 等待数据加载完成
      await this.loadMainQuestionAnswers(question.questionId, question.questionIndex);

      // 保存浏览记录
      this.saveViewHistory();
    },
    setCurrentMaterial(material) {
      this.currentMaterialIndex = material.materialIndex;
    },
    setCurrentAnswer(index) {
      this.currentAnswerIndex = index;
    },

    onEditorChange: _.debounce(function({ quill, html, text }) {
      this.userAnswer = html;
      // 清理文本，移除换行符、回车符和空格，只计算实际文字长度
      const cleanText = text.replace(/[(^*\n*)|(^*\r*)]/g, '');
      this.userAnswerContentLength = cleanText.length;
    }, 300),
    reviewAnswers() {
      this.showAnswerDrawer = true;
    },
    addAnswer() {
      const query = {
        paperId: this.paperId
      };

      if (this.currentQuestionIndex) {
        query.questionIndex = this.currentQuestionIndex;
      }

      this.$router.push({
        path: '/community/studyRoom/addAnswer',
        query
      });
    },
    
    cancelOverlapComparison() {
      this.overlapJobId += 1;
      if (this.overlapTask) {
        this.overlapTask.cancel();
        this.overlapTask = null;
      }
      this.comparingOverlap = false;
    },

    async compareOverlap() {
      if (this.comparingOverlap) {
        return;
      }

      let jobId = null;
      try {
        // 创建临时 div 来解析 HTML 内容
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = this.userAnswer;
        const plainUserAnswer = tempDiv.textContent || tempDiv.innerText || '';

        if (!plainUserAnswer.trim()) {
          this.$message.warning('请先输入答案内容');
          return;
        }

        // 备份原始答案（只在第一次进行高亮时备份）
        if (!this.isHighlighted) {
          this.originalAnswers = this.answers.map(answer => ({ ...answer }));
          this.originalUserAddAnswers = this.userAddAnswers.map(answer => ({ ...answer }));
        }

        const baseAnswers = this.originalAnswers;
        const baseUserAddAnswers = this.originalUserAddAnswers;
        const allAnswers = [...baseAnswers, ...baseUserAddAnswers];
        const plainContents = allAnswers.map(answer => {
          const content = String(answer?.content ?? '');
          tempDiv.innerHTML = content;
          return tempDiv.textContent || tempDiv.innerText || '';
        });

        this.comparingOverlap = true;
        jobId = ++this.overlapJobId;
        const task = createOverlapWorkerTask(plainUserAnswer, plainContents, 5);
        this.overlapTask = task;
        const rangeResults = await task.promise;

        // 用户切换题目或离开页面后，丢弃旧任务结果。
        if (jobId !== this.overlapJobId) {
          return;
        }

        let hasHighlight = false;
        const highlightedAnswers = allAnswers.map((answer, index) => {
          const content = String(answer?.content ?? '');
          const ranges = Array.isArray(rangeResults[index]) ? rangeResults[index] : [];
          if (ranges.length > 0) {
            hasHighlight = true;
          }
          return {
            ...answer,
            content: highlightHtmlByRanges(content, ranges)
          };
        });

        this.answers = highlightedAnswers.slice(0, baseAnswers.length);
        this.userAddAnswers = highlightedAnswers.slice(baseAnswers.length);
        this.isHighlighted = hasHighlight;

        if (hasHighlight) {
          this.$message.success('在答案页签中查看对比结果');
        } else {
          this.$message.warning('无五字以上重复内容');
        }
      } catch (error) {
        if (error?.name === 'AbortError') {
          return;
        }
        console.error('对比重合度时出错:', error);
        this.$message.error('对比重合度失败，请重试');
      } finally {
        // 旧任务被取消后不能清理后续新任务的状态。
        if (jobId === null || jobId === this.overlapJobId) {
          this.overlapTask = null;
          this.comparingOverlap = false;
        }
      }
    },

    submit(submitType) {
      if (submitType === 'submit-user-answer' && !this.canSubmitAnswer) {
        return;
      }

      if (submitType === 'submit-user-answer') {
        this.$confirm('是否上传答案至答案库?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading.submitAnswer = true;
          const data = {
            content: this.userAnswer,
            userId: this.$store.getters['user/getState'].userId,
            questionId: this.currentQuestion.questionId
          };
          
          return insertUserAnswer(data)
            .then(res => {
              this.userAnswer = '';
              this.userAnswerContentLength = 0;
              this.$message.success('提交成功');
              // 刷新用户答案列表和统计
              this.getUserAnswerList(this.currentQuestion.questionId);
            })
            .catch(err => {
              console.error(err);
              this.$message.error('提交失败，请重试');
            })
            .finally(() => {
              this.loading.submitAnswer = false;
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      }
    },

    changeActionStatus(targetType, actionType, targetId, status) {
				  if(targetType == 3) {
					if(actionType == 1) {
						let answerActionSupportList = this.answerActionSupportList;
						let targetIndex = this.answerActionSupportList.findIndex(item => item.targetId === targetId);
						answerActionSupportList[targetIndex].status = status;
						answerActionSupportList[targetIndex].count = answerActionSupportList[targetIndex].count + (status == "1" ? 1 : -1);
						this.answerActionSupportList = answerActionSupportList;
					  }
					if(actionType == 2) {
						let answerActionAgainstList = this.answerActionAgainstList;
						let targetIndex = this.answerActionAgainstList.findIndex(item => item.targetId === targetId);
						answerActionAgainstList[targetIndex].status = status;
						answerActionAgainstList[targetIndex].count = answerActionAgainstList[targetIndex].count + (status == "1" ? 1 : -1);
						this.answerActionAgainstList = answerActionAgainstList;
					}
				}
				if(targetType == 4) {
					if (actionType == 1) {
						let addActionSupportList = this.addActionSupportList;
						let targetIndex = addActionSupportList.findIndex(item => item.targetId == targetId);
						addActionSupportList[targetIndex].status = status;
						addActionSupportList[targetIndex].count = addActionSupportList[targetIndex].count + (status ==
							"1" ? 1 : -1);
						this.addActionSupportList = addActionSupportList;
					}
					if (actionType == 2) {
						let addActionAgainstList = this.addActionAgainstList;
						let targetIndex = addActionAgainstList.findIndex(item => item.targetId == targetId);
						addActionAgainstList[targetIndex].status = status;
						addActionAgainstList[targetIndex].count = addActionAgainstList[targetIndex].count + (status ==
							"1" ? 1 : -1);
						this.addActionAgainstList = addActionAgainstList;
					}
				}
		},

    async action(e) {
      let data = {
        status: e[0],
        actionType: e[1],
        targetType: e[2],
        targetId: e[3]
      };
      try {
        await doAction(data);
        if (data.targetType == 1) {
          let paperActionTarget = this.paperActionTarget;
          paperActionTarget.status = data.status;
          this.paperActionTarget = paperActionTarget;
        } else if(data.targetType == 3 || data.targetType == 4) {
          if (data.status == '1') {
            let data1 = JSON.parse(JSON.stringify(data));
            data1.status = '0';
            let doAc = false;
            if (data1.actionType == 1) {
              // 移除踩
              data1.actionType = 2;
              // 参考答案
              if(data.targetType == 3) {
                let target = this.answerActionAgainstList.find(item => item.targetId === data.targetId);
                if(target && target.status == '1') {
                  doAc = true;
                }
              }
              // 补充答案
              if(data.targetType == 4) {
                let target = this.addActionAgainstList.find(item => item.targetId === data.targetId);
                if(target && target.status == '1') {
                  doAc = true;
                }
              }
            } else if (data1.actionType == 2) {
              // 移除赞
              data1.actionType = 1;
              // 参考答案
              if(data.targetType == 3) {
                let target = this.answerActionSupportList.find(item => item.targetId === data.targetId);
                if(target && target.status == '1') {
                  doAc = true;
                }
              }
              // 补充答案
              if(data.targetType == 4) {
                let target = this.addActionSupportList.find(item => item.targetId === data.targetId);
                if(target && target.status == '1') {
                  doAc = true;
                }
              }
            }
            if (doAc) {
              await doAction(data1);
            }
          }
          
          // 更新点赞点踩数量
          if (data.targetType === 3) {
            const mainAnswerIds = this.answers.map(answer => answer.answerId).filter(Boolean).join(',');
            const compareAnswerIds = this.comparePaper && this.comparePaper.answers
              ? this.comparePaper.answers.map(answer => answer.answerId).filter(Boolean).join(',')
              : '';
            const refreshTasks = [];
            if (this.answers.some(answer => answer.answerId === data.targetId) && mainAnswerIds) {
              refreshTasks.push(this.getInstitutionAnswerActionCounts(mainAnswerIds));
            }
            if (compareAnswerIds && this.comparePaper.answers.some(answer => answer.answerId === data.targetId)) {
              refreshTasks.push(this.getCompareInstitutionAnswerActionCounts(compareAnswerIds));
            }
            if (refreshTasks.length > 0) {
              await Promise.all(refreshTasks);
            }
          } else if (data.targetType === 4) {
            const mainAddIds = this.userAddAnswers.map(answer => answer.addId).filter(Boolean).join(',');
            const compareAddIds = this.comparePaper && this.comparePaper.userAddAnswers
              ? this.comparePaper.userAddAnswers.map(answer => answer.addId).filter(Boolean).join(',')
              : '';
            const refreshTasks = [];
            if (this.userAddAnswers.some(answer => answer.addId === data.targetId) && mainAddIds) {
              refreshTasks.push(this.getAddAnswerActionCounts(mainAddIds));
            }
            if (compareAddIds && this.comparePaper.userAddAnswers.some(answer => answer.addId === data.targetId)) {
              refreshTasks.push(this.getCompareAddAnswerActionCounts(compareAddIds));
            }
            if (refreshTasks.length > 0) {
              await Promise.all(refreshTasks);
            }
          }
        }
      } catch (error) {
        console.error('操作失败:', error);
        this.$message.error('操作失败，请重试');
      }
    },

    async getPaperList(paperId) {
      this.loading = true;
      try {
        let params = {
          paperId: paperId,
          pageSize: 1000,
          pageNum: 1
        };
        const response = await getPaperList(params);
        if (response.rows.length > 0) {
          let paper = response.rows[0];
          this.paperTitle = paper.title;
          params = {};
          params.targetType = 1;
          params.actionType = 3;
          params.targetIds = paperId;
          const actionResponse = await getTargetsActionStatus(params);
          this.paperActionTarget = actionResponse.data.find(item => item.targetId == this.paperId);
        }
      } catch (error) {
        this.$message.error(error);
      }
    },

    async getQuestionList(paperId) {
      const params = {
        paperId: paperId,
        pageSize: 1000,
        pageNum: 1
      };

      const response = await getQuestionList(params);
      this.questions = response.rows || [];
      if (this.questions.length > 0) {
        // 根据 currentQuestionIndex 找到对应的题目
        const currentQuestion = this.questions.find(q => q.questionIndex == this.currentQuestionIndex);
        if (currentQuestion) {
          // 加载当前题目的答案，而不是总是加载第一题
          await this.loadMainQuestionAnswers(currentQuestion.questionId, currentQuestion.questionIndex);
        } else {
          // 如果找不到对应的题目，则加载第一题
          this.currentQuestionIndex = this.questions[0].questionIndex || 1;
          await this.loadMainQuestionAnswers(this.questions[0].questionId, this.currentQuestionIndex);
        }
      }
    },

    async loadMainQuestionAnswers(questionId, questionIndex) {
      const requestSeq = ++this.answerRequestSeq;
      this.resetMainAnswerState();
      await Promise.all([
        this.getAnswerList(questionId, requestSeq, questionIndex),
        this.getUserAddAnswerList(questionId, requestSeq, questionIndex)
      ]);
    },

    async getAnswerList(questionId, requestSeq = this.answerRequestSeq, questionIndex = this.currentQuestionIndex) {
      const params = {
        questionId: questionId,
        pageSize: 1000,
        pageNum: 1
      };
      try {
        const response = await getAnswerList(params);
        if (requestSeq !== this.answerRequestSeq || !this.isCurrentQuestionRequest(questionId, questionIndex)) {
          return;
        }
        this.answers = this.filterAnswerRowsByQuestion(response.rows, questionId, questionIndex);
        if (this.answers.length > 0) {
          const answerIds = this.answers.map(answer => answer.answerId).filter(Boolean).join(',');
          if (answerIds) {
            await this.getInstitutionAnswerActionCounts(
              answerIds,
              () => requestSeq === this.answerRequestSeq && this.isCurrentQuestionRequest(questionId, questionIndex)
            );
          } else {
            this.answerActionSupportList = [];
            this.answerActionAgainstList = [];
          }
        } else {
          this.answerActionSupportList = [];
          this.answerActionAgainstList = [];
        }
      } catch (error) {
        if (requestSeq !== this.answerRequestSeq || !this.isCurrentQuestionRequest(questionId, questionIndex)) {
          return;
        }
        console.error('获取答案列表失败:', error);
        this.$message.error('获取答案列表失败');
      }
    },

    async getUserAddAnswerList(questionId, requestSeq = this.answerRequestSeq, questionIndex = this.currentQuestionIndex) {
      const params = {
        questionId: questionId,
        pageSize: 1000,
        pageNum: 1,
        status: 1
      };
      try {
        const response = await getUserAddAnswerList(params);
        if (requestSeq !== this.answerRequestSeq || !this.isCurrentQuestionRequest(questionId, questionIndex)) {
          return;
        }
        this.userAddAnswers = this.filterAnswerRowsByQuestion(response.rows, questionId, questionIndex);
        if (this.userAddAnswers.length > 0) {
          const answerIds = this.userAddAnswers.map(answer => answer.addId).join(',');
          if (answerIds) {
            await this.getAddAnswerActionCounts(
              answerIds,
              () => requestSeq === this.answerRequestSeq && this.isCurrentQuestionRequest(questionId, questionIndex)
            );
          } else {
            this.addActionSupportList = [];
            this.addActionAgainstList = [];
          }
        } else {
          this.addActionSupportList = [];
          this.addActionAgainstList = [];
        }
      } catch (error) {
        if (requestSeq !== this.answerRequestSeq || !this.isCurrentQuestionRequest(questionId, questionIndex)) {
          return;
        }
        console.error('获取用户补充答案列表失败:', error);
        this.$message.error('获取用户补充答案列表失败');
      }
    },

    async getMaterialList(paperId) {
      const params = {
        paperId: paperId,
        pageSize: 1000,
        pageNum: 1
      };
      const response = await getMaterialList(params);
      this.materials = response.rows || [];
    },

    toggleCompareMode() {
      const versionInfo = this.$store.getters["user/getState"].versionInfo || {};
      // 检查是否有同屏对比权限
      if (!hasSideComparePermission(versionInfo)) {
        showPermissionDeniedTip(['side_compare'], this);
        return;
      }

      this.isCompareMode = !this.isCompareMode;
      if (!this.isCompareMode) {
        this.selectedPaper = [];
        this.comparePaper = null;
        this.$message.success('已退出同屏对比模式');
      } else {
        this.$message.success('已开启同屏对比模式，请选择要对比的试卷');
      }
    },
    async handlePaperChange(value) {
      if (value && value.length === 2) {
        const region = this.regionPaperOptions.find(item => item.value === value[0]);

        try {
          const [questionsResponse, materialsResponse] = await Promise.all([
          getQuestionList({
            paperId: value[1],
            pageSize: 1000,
            pageNum: 1
          }),
          getMaterialList({
            paperId: value[1],
            pageSize: 1000,
            pageNum: 1
          })
          ]);

          this.comparePaper = {
            region: region.label,
            paper: value[1],
            value: value[1],
            questions: questionsResponse.rows || [],
            materials: materialsResponse.rows || [],
            answers: [],
            userAddAnswers: [],
            currentQuestionIndex: 1,
            currentAnswerIndex: 0
          };

          // 初始化对比材料索引
          this.compareMaterialIndex = 1;

          if (questionsResponse.rows && questionsResponse.rows.length > 0) {
            const firstQuestion = questionsResponse.rows[0];
            this.comparePaper.currentQuestionIndex = firstQuestion.questionIndex || 1;
            await this.loadCompareQuestionData(firstQuestion.questionId, this.comparePaper.currentQuestionIndex);
          }
        } catch (error) {
          this.$message.error(error);
        }
      }
    },
    async setCompareQuestionIndex(index) {
      if (this.comparePaper) {
        const currentQuestion = this.comparePaper.questions.find(question => String(question.questionIndex) === String(index));
        if (currentQuestion) {
          this.comparePaper.currentQuestionIndex = index;
          this.comparePaper.currentAnswerIndex = 0;
          this.resetCompareAnswerState();
          try {
            await this.loadCompareQuestionData(currentQuestion.questionId, index);
          } catch (error) {
            this.$message.error('获取对比答案失败');
            this.comparePaper.answers = [];
            this.comparePaper.userAddAnswers = [];
          }
        }
      }
    },
    async setCompareAnswerIndex(index) {
      if (this.comparePaper) {
        this.comparePaper.currentAnswerIndex = index;
      }
    },
    async loadCompareQuestionData(questionId, questionIndex) {
      if (!this.comparePaper) return;
      const requestSeq = ++this.compareAnswerRequestSeq;

      try {
        const [answersResponse, userAddAnswersResponse] = await Promise.all([
          getAnswerList({
            questionId: questionId,
            pageSize: 1000,
            pageNum: 1
          }),
          getUserAddAnswerList({
            questionId: questionId,
            pageSize: 1000,
            pageNum: 1,
            status: 1
          })
        ]);
        if (requestSeq !== this.compareAnswerRequestSeq || !this.isCurrentCompareQuestionRequest(questionId, questionIndex)) {
          return;
        }

        this.comparePaper.answers = this.filterAnswerRowsByQuestion(answersResponse.rows, questionId, questionIndex);
        this.comparePaper.userAddAnswers = this.filterAnswerRowsByQuestion(userAddAnswersResponse.rows, questionId, questionIndex);

        if (this.comparePaper.answers.length > 0) {
          const answerIds = this.comparePaper.answers.map(answer => answer.answerId).filter(Boolean).join(',');
          if (answerIds) {
            await this.getCompareInstitutionAnswerActionCounts(
              answerIds,
              () => requestSeq === this.compareAnswerRequestSeq && this.isCurrentCompareQuestionRequest(questionId, questionIndex)
            );
          } else {
            this.compareAnswerActionSupportList = [];
            this.compareAnswerActionAgainstList = [];
          }
        } else {
          this.compareAnswerActionSupportList = [];
          this.compareAnswerActionAgainstList = [];
        }

        if (this.comparePaper.userAddAnswers.length > 0) {
          const addAnswerIds = this.comparePaper.userAddAnswers.map(answer => answer.addId).filter(Boolean).join(',');
          if (addAnswerIds) {
            await this.getCompareAddAnswerActionCounts(
              addAnswerIds,
              () => requestSeq === this.compareAnswerRequestSeq && this.isCurrentCompareQuestionRequest(questionId, questionIndex)
            );
          } else {
            this.compareAddActionSupportList = [];
            this.compareAddActionAgainstList = [];
          }
        } else {
          this.compareAddActionSupportList = [];
          this.compareAddActionAgainstList = [];
        }
      } catch (error) {
        if (requestSeq !== this.compareAnswerRequestSeq || !this.isCurrentCompareQuestionRequest(questionId, questionIndex)) {
          return;
        }
        this.comparePaper.answers = [];
        this.comparePaper.userAddAnswers = [];
        this.compareAnswerActionSupportList = [];
        this.compareAnswerActionAgainstList = [];
        this.compareAddActionSupportList = [];
        this.compareAddActionAgainstList = [];
        throw error;
      }
    },
    initRegionOptions() {
      this.regionPaperOptions = this.areaList.map(area => ({
        label: area.content,
        value: area.areaId,
        leaf: false
      }));
    },
    loadPaperOptions(node, resolve) {
      if (node.level === 0) {
        resolve(this.regionPaperOptions);
        return;
      }

      if (node.level === 1) {
        getPaperList({
          pageSize: 1000,
          pageNum: 1,
          areaId: node.value
        }).then(response => {
          const papers = (response.rows || []).map(paper => ({
            label: paper.title,
            value: paper.paperId,
            leaf: true
          }));
          resolve(papers);
        }).catch(() => {
          resolve([]);
        });
      }
    },
    handleDrawerClose(done) {
      this.commentContent = '';
      done();
    },
    openQuestionComment() {
      if (!this.currentQuestion || !this.currentQuestion.questionId) return;
      this.commentTarget = {
        targetType: 2,
        targetId: this.currentQuestion.questionId,
        mode: 'question'
      };
      this.showCommentDrawer = true;
      this.getUserCommentList(this.commentTarget.targetId, this.commentTarget.targetType);
    },
    openAnswerComment(targetType, targetId) {
      if (!targetId) return;
      this.commentTarget = {
        targetType,
        targetId,
        mode: 'answer'
      };
      this.showCommentDrawer = true;
      this.getUserCommentList(targetId, targetType);
    },
    findAnswerByTarget(targetType, targetId) {
      const targetKey = Number(targetType) === 4 ? 'addId' : 'answerId';
      const candidateLists = Number(targetType) === 4
        ? [this.userAddAnswers || [], this.compareUserAddAnswers || []]
        : [this.answers || [], this.compareAnswers || []];
      for (const list of candidateLists) {
        const target = list.find(item => item[targetKey] === targetId);
        if (target) {
          return target;
        }
      }
      return null;
    },
    isAnswerReported(answer) {
      return answer && String(answer.reportStatus) === '1';
    },
    openReportModal(targetType, targetId) {
      const targetAnswer = this.findAnswerByTarget(targetType, targetId);
      if (this.isAnswerReported(targetAnswer)) {
        this.$message.info('该答案已举报');
        return;
      }
      this.reportTarget = {
        targetType,
        targetId
      };
      const defaultType = this.reportTypeOptions[0] || { type: 101, name: '内容错漏' };
      this.reportForm = {
        type: defaultType.type,
        reason: defaultType.name,
        content: ''
      };
      this.showReportDialog = true;
      getReportType({ targetType }).then(res => {
        if (res && Array.isArray(res.data) && res.data.length > 0) {
          this.reportTypeOptions = res.data.map(item => ({
            type: item.type,
            name: item.name
          }));
          this.reportForm.type = this.reportTypeOptions[0].type;
          this.reportForm.reason = this.reportTypeOptions[0].name;
        }
      }).catch(() => {});
    },
    selectReportType(item) {
      this.reportForm.type = item.type;
      this.reportForm.reason = item.name;
    },
    submitReport() {
      if (this.reportSubmitting) return;
      if (!this.reportForm.type) {
        this.$message.warning('请选择举报原因');
        return;
      }
      this.reportSubmitting = true;
      insertReport({
        type: this.reportForm.type,
        reason: this.reportForm.reason,
        targetType: this.reportTarget.targetType,
        targetId: this.reportTarget.targetId,
        content: (this.reportForm.content || '').trim()
      }).then(res => {
        if (res.code === 200) {
          const targetAnswer = this.findAnswerByTarget(this.reportTarget.targetType, this.reportTarget.targetId);
          if (targetAnswer) {
            this.$set(targetAnswer, 'reportStatus', '1');
          }
          this.$message.success('举报提交成功');
          this.showReportDialog = false;
        } else {
          this.$message.error(res.msg || '举报提交失败');
        }
      }).catch(() => {
        this.$message.error('举报提交失败');
      }).finally(() => {
        this.reportSubmitting = false;
      });
    },
    submitComment() {
      if (!this.canSubmitComment) return;
      
      this.loading.submitComment = true;
      
      const data = {
        userId: this.$store.getters['user/getState'].userId,
        targetType: this.commentTarget.targetType || 2,
        targetId: this.commentTarget.targetId || this.currentQuestion.questionId,
        content: this.commentContent
      };
      
      insertUserComment(data)
        .then(() => {
          this.$message.success('评论发表成功！');
          this.commentContent = '';
          // 重新获取评论列表
          this.getUserCommentList(data.targetId, data.targetType);
        })
        .catch(error => {
          this.$message.error(error);
        })
        .finally(() => {
          this.loading.submitComment = false;
        });
    },
    getUserCommentList(targetId, targetType = 2) {
      const params = {
        ...this.pageParams,
        targetId: targetId,
        targetType: targetType
      };
      getUserCommentList(params).then(response => {
        this.commentList = response.rows || [];
      }).catch(error => {
        this.$message.error(error);
        this.commentList = [];
      });
    },
    formatTime(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      const now = new Date();
      const diff = now - date;
      
      // 小于1分钟
      if (diff < 60000) {
        return '刚刚';
      }
      // 小于1小时
      if (diff < 3600000) {
        return Math.floor(diff / 60000) + '分钟前';
      }
      // 小于24小时
      if (diff < 86400000) {
        return Math.floor(diff / 3600000) + '小时前';
      }
      // 小于30天
      if (diff < 2592000000) {
        return Math.floor(diff / 86400000) + '天前';
      }
      
      // 超过30天显示具体日期
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hour = date.getHours().toString().padStart(2, '0');
      const minute = date.getMinutes().toString().padStart(2, '0');
      
      if (year === now.getFullYear()) {
        return `${month}-${day} ${hour}:${minute}`;
      }
      return `${year}-${month}-${day} ${hour}:${minute}`;
    },
    handleNoteDrawerClose(done) {
      this.noteContent = '';
      done();
    },
    submitNote() {
      if (!this.canSubmitNote) return;
      
      this.loading.submitNote = true;
      
      const data = {
        userId: this.$store.getters['user/getState'].userId,
        targetType: 2, // 2 代表题目
        targetId: this.currentQuestion.questionId,
        content: this.noteContent
      };
      
      insertUserNote(data)
        .then(() => {
          this.$message.success('笔记保存成功！');
          this.noteContent = '';
          // 重新获取笔记列表
          this.getUserNoteList(this.currentQuestion.questionId);
        })
        .catch(error => {
          console.error(error);
          this.$message.error('笔记保存失败，请重试');
        })
        .finally(() => {
          this.loading.submitNote = false;
        });
    },
    deleteNote(noteId) {
      if (this.loading.deleteNote) return;

      this.$confirm('确定要删除这条笔记吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading.deleteNote = true;
        
        deleteUserNote(noteId)
          .then(() => {
            this.noteList = this.noteList.filter(note => note.noteId !== noteId);
            this.$message.success('笔记删除成功！');
          })
          .catch(error => {
            console.error(error);
            this.$message.error('删除笔记失败，请重试');
          })
          .finally(() => {
            this.loading.deleteNote = false;
          });
      }).catch(() => {});
    },
    toggleImmersive() {
      this.isImmersive = !this.isImmersive;
      this.$message.success(this.isImmersive ? '已开启沉浸模式' : '已退出沉浸模式');
    },
    getUserNoteList(questionId) {
      const params = {
        targetId: questionId,
        targetType: 2,
        pageSize: 1000,
        pageNum: 1,
        userId: this.$store.getters['user/getState'].userId
      };
      
      getUserNoteList(params)
        .then(response => {
          this.noteList = response.rows || [];
        })
        .catch(error => {
          console.error(error);
          this.$message.error('获取笔记列表失败');
          this.noteList = [];
        });
    },
    deleteComment(commentId) {
      if (this.loading.deleteComment) return;

      this.$confirm('确定要删除这条评论吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading.deleteComment = true;
        
        deleteUserComment(commentId)
          .then(() => {
            this.commentList = this.commentList.filter(comment => comment.commentId !== commentId);
            this.$message.success('评论删除成功！');
            this.getUserCommentList(this.commentTarget.targetId, this.commentTarget.targetType);
          })
          .catch(error => {
            console.error(error);
            this.$message.error('删除评论失败，请重试');
          })
          .finally(() => {
            this.loading.deleteComment = false;
          });
      }).catch(() => {});
    },
    getUserAnswerList(questionId) {
      const params = {
        questionId: questionId,
        pageSize: 1000,
        pageNum: 1,
        userId: this.$store.getters['user/getState'].userId
      };
      
      getUserAnswerList(params)
        .then(response => {
          this.userAnswers = response.rows || [];
          this.userAnswerCount = this.userAnswers.length;
        })
        .catch(error => {
          console.error(error);
          this.$message.error('获取答案列表失败');
          this.userAnswers = [];
          this.userAnswerCount = 0;
        });
    },
    handleAnswerDrawerClose(done) {
      done();
    },
    handleMaterialDrawerClose(done) {
      done();
    },
    handleCompareMaterialDrawerClose(done) {
      done();
    },
    setCompareMaterial(material) {
      this.compareMaterialIndex = material.materialIndex;
    },
    deleteUserAnswer(answerId) {
      if (this.loading.deleteAnswer) return;

      this.$confirm('确定要删除这条答案记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading.deleteAnswer = true;
        
        deleteUserAnswer(answerId)
          .then(() => {
            this.userAnswers = this.userAnswers.filter(answer => answer.answerId !== answerId);
            this.userAnswerCount = this.userAnswers.length;
            this.$message.success('答案删除成功！');
          })
          .catch(error => {
            console.error(error);
            this.$message.error('删除答案失败，请重试');
          })
          .finally(() => {
            this.loading.deleteAnswer = false;
          });
      }).catch(() => {});
    },
    // 获取机构答案的点赞点踩数量
    async getInstitutionAnswerActionCounts(answerId, shouldApply = () => true) {
      try {
        // 获取点赞数量
        const supportParams = {
          targetIds: answerId,
          targetType: 3,  // 3表示机构答案
          actionType: 1   // 1表示点赞
        };
        const supportRes = await getTargetsActionStatus(supportParams);
        if (!shouldApply()) return;
        if (supportRes.code === 200) {
          this.answerActionSupportList = supportRes.data || [];
        }

        // 获取点踩数量
        const againstParams = {
          targetIds: answerId,
          targetType: 3,  // 3表示机构答案
          actionType: 2   // 2表示点踩
        };
        const againstRes = await getTargetsActionStatus(againstParams);
        if (!shouldApply()) return;
        if (againstRes.code === 200) {
          this.answerActionAgainstList = againstRes.data || [];
        }
      } catch (error) {
        if (!shouldApply()) return;
        console.error('获取机构答案点赞点踩数量失败:', error);
      }
    },

    // 获取用户补充答案的点赞点踩数量
    async getAddAnswerActionCounts(answerIds, shouldApply = () => true) {
      try {
        // 获取点赞数量
        const supportParams = {
          targetIds: answerIds,
          targetType: 4,  // 4表示用户补充答案
          actionType: 1   // 1表示点赞
        };
        const supportRes = await getTargetsActionStatus(supportParams);
        if (!shouldApply()) return;
        if (supportRes.code === 200) {
          this.addActionSupportList = supportRes.data || [];
        }

        // 获取点踩数量
        const againstParams = {
          targetIds: answerIds,
          targetType: 4,  // 4表示用户补充答案
          actionType: 2   // 2表示点踩
        };
        const againstRes = await getTargetsActionStatus(againstParams);
        if (!shouldApply()) return;
        if (againstRes.code === 200) {
          this.addActionAgainstList = againstRes.data || [];
        }
      } catch (error) {
        if (!shouldApply()) return;
        console.error('获取答案列表失败:', error);
        this.$message.error('获取答案列表失败');
      }
    },

    // 获取对比试卷机构答案的点赞点踩数量
    async getCompareInstitutionAnswerActionCounts(answerId, shouldApply = () => true) {
      try {
        // 获取点赞数量
        const supportParams = {
          targetIds: answerId,
          targetType: 3,  // 3表示机构答案
          actionType: 1   // 1表示点赞
        };
        const supportRes = await getTargetsActionStatus(supportParams);
        if (!shouldApply()) return;
        if (supportRes.code === 200) {
          this.compareAnswerActionSupportList = supportRes.data || [];
        }

        // 获取点踩数量
        const againstParams = {
          targetIds: answerId,
          targetType: 3,  // 3表示机构答案
          actionType: 2   // 2表示点踩
        };
        const againstRes = await getTargetsActionStatus(againstParams);
        if (!shouldApply()) return;
        if (againstRes.code === 200) {
          this.compareAnswerActionAgainstList = againstRes.data || [];
        }
      } catch (error) {
        if (!shouldApply()) return;
        console.error('获取对比试卷机构答案点赞点踩数量失败:', error);
      }
    },

    // 获取对比试卷用户补充答案的点赞点踩数量
    async getCompareAddAnswerActionCounts(answerIds, shouldApply = () => true) {
      try {
        // 获取点赞数量
        const supportParams = {
          targetIds: answerIds,
          targetType: 4,  // 4表示用户补充答案
          actionType: 1   // 1表示点赞
        };
        const supportRes = await getTargetsActionStatus(supportParams);
        if (!shouldApply()) return;
        if (supportRes.code === 200) {
          this.compareAddActionSupportList = supportRes.data || [];
        }

        // 获取点踩数量
        const againstParams = {
          targetIds: answerIds,
          targetType: 4,  // 4表示用户补充答案
          actionType: 2   // 2表示点踩
        };
        const againstRes = await getTargetsActionStatus(againstParams);
        if (!shouldApply()) return;
        if (againstRes.code === 200) {
          this.compareAddActionAgainstList = againstRes.data || [];
        }
      } catch (error) {
        if (!shouldApply()) return;
        console.error('获取对比试卷用户补充答案点赞点踩数量失败:', error);
      }
    },

    // 处理复制事件,进行权限检查
    handleCopyEvent(event) {
      // 获取用户版本信息
      const versionInfo = this.$store.getters["user/getState"].versionInfo || {};

      // 检查复制权限
      if (!hasCopyPermission(versionInfo)) {
        // 阻止复制
        event.preventDefault();
        // 显示权限不足提示
        showPermissionDeniedTip(['copy'], this);
      }
      // 如果有权限,不做任何处理,允许浏览器默认的复制行为
    }
  },
  watch: {
      areaList: {
        handler(newVal) {
          if (newVal && newVal.length > 0) {
            this.initRegionOptions();
          }
        },
        immediate: true
      },
      showCommentDrawer(newVal) {
        if (newVal) {
          const targetId = this.commentTarget.targetId || this.currentQuestion.questionId;
          const targetType = this.commentTarget.targetType || 2;
          this.getUserCommentList(targetId, targetType);
        }
      },
      showNoteDrawer(newVal) {
        if (newVal) {
          this.getUserNoteList(this.currentQuestion.questionId);
        }
      },
      showAnswerDrawer(newVal) {
        if (newVal) {
          this.getUserAnswerList(this.currentQuestion.questionId);
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
.body-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  padding: 0 20px;
  box-sizing: border-box;
  .index-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    .action-buttons {
      width: 5%;
      margin-right: 12px;
      z-index: 2;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;

      .icon-button {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        padding: 0;
        margin-bottom: 15px;
        background-color: white;
        border: 1px solid #dce6e3b0;
        display: block;
        text-align: center;
        margin-left: 0px !important;
        transition: all 0.3s;

        &:hover {
          background-color: #f2f6fc8a;
          transform: scale(1.1);

          :deep(i) {
            color: #46B4B1;
          }
        }

        :deep(i) {
          font-size: 20px;
          color: #606266;
          transition: color 0.3s;

          &.el-icon-star-on {
            color: #46B4B1;
          }
        }
      }
    }
  }
}

.answer-actions {
  display: flex;
  align-items: center;
  margin-top: 12px;
  margin-bottom: 12px;

  .action-button {
    padding: 5px 10px;
    margin: 0 10px;
    background-color: #46B4B1;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
      background-color: #378F8C;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.65;
      background-color: #46B4B1;
    }
  }
}

.report-dialog-tip {
  margin-bottom: 12px;
  font-size: 13px;
  color: #909399;
  line-height: 1.6;
}

.report-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}

.report-tag {
  border: none;
  background: #f5f7fa;
  color: #606266;
  border-radius: 16px;
  padding: 7px 14px;
  cursor: pointer;
  transition: all 0.2s;

  &.active {
    background: rgba(70, 180, 177, 0.12);
    color: #46B4B1;
  }
}

.dialog-footer {
  :deep(.report-cancel-btn) {
    color: #606266;
    border-color: #dcdfe6;
    background-color: #fff;

    &:hover,
    &:focus {
      color: #46B4B1;
      border-color: rgba(70, 180, 177, 0.45);
      background-color: rgba(70, 180, 177, 0.08);
    }
  }

  :deep(.report-submit-btn) {
    background-color: #46B4B1;
    border-color: #46B4B1;

    &:hover,
    &:focus {
      background-color: #3da7a4;
      border-color: #3da7a4;
    }
  }
}

.question-section {
  width: 50%;
  padding-right: 20px;
  transition: all 0.3s ease;
  &.full-width {
    width: calc(1200px - 60px);
    padding-right: 0;
  }
  .no-permission {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
    img {
      width: 221px;
    }
	}
}

.materials-section {
  width: 45%;
  padding-left: 20px;
  border-left: 1px solid #e0e0e0;
  min-width: 0;
  min-height: 80vh;
  overflow-y: auto;
}

.question-tabs,
.materials-tabs,
.answer-tabs {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  margin-top: 12px;
}

.answer-tabs {
  .add-answer-tab-action {
    margin-left: auto;
    min-height: 30px;
    padding: 5px 12px;
    color: #46B4B1;
    border: 1px solid #46B4B1;
    border-radius: 4px;
    background: #fff;
    line-height: 1;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      color: #fff;
      background: #46B4B1;
    }
  }
}

.paper-text {
  font-size: 18px;
  text-align: center;
  color: #333;
}

.materials-tabs-container {
  overflow-x: auto;
  white-space: normal;
}

.materials-tabs-container::-webkit-scrollbar {
  display: none;
}

.materials-tabs .tab-button:nth-child(9n) {
  margin-right: 0;
}

.tab-button {
  margin: 0 15px 0 0;
  border: none;
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  align-content: center;
  padding: 5px 15px;
  transition: all 0.3s;
  position: relative;
}

.tab-button:hover {
  color: #46B4B1;
}

.tab-button.active {
  color: #46B4B1;
}

.tab-button.active::after {
  content: '';
  width: 50%;
  height: 8px;
  background: #46B4B1;
  transform: scaleY(.5);
  position: absolute;
  bottom: -4px;
  right: 0;
  align-items: center;
  left: 25%;
}

.answer-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.answer-box {
  margin-top: 12px;
  position: relative;

  .editor-footer {
    position: absolute;
    left: 12px;
    bottom: 20px;
    font-size: 12px;
    color: #999;
    background-color: #f9f9f9;
    padding: 2px 6px;
    border-radius: 3px;
    z-index: 1;

    .char-count {
      font-weight: 400;
    }
  }

  .answer-info {
    position: absolute;
    right: 0px;
    top: 0px;
    margin-top: 10px;
    font-size: 12px;
    color: #666;

    .review-link {
      text-decoration: underline;
      color: #46B4B1;
      cursor: pointer;
    }

    &:hover {
      color: #378F8C;
    }
  }
}

.ql-editor {
  width: 100%; /* 占满父级宽度 */
  box-sizing: border-box; /* 确保 padding 和 border 不会超出父级宽度 */
}

:deep(.quill-editor) {
  font-size: 14px;
  .ql-container{
    min-height: 150px;
    border: none;
    background-color: #f9f9f9;
    border-radius: 10px;
  }
  .ql-toolbar.ql-snow {
    border: none !important;
  }
}

.content-area {
  background-color: #f9f9f9;
  padding: 16px;
  border-radius: 10px;
  font-size: 14px;
  line-height: 1.4;
  color: #333;
  overflow-x: auto;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    z-index: 1;
    pointer-events: none;
  }

  .header .left {
    color: #46B4B1;
  }
}

:deep(.answer-actions .report-btn),
:deep(.answer-header .report-btn),
:deep(.answer-actions .comment-btn),
:deep(.answer-header .comment-btn) {
  min-width: 28px;
  padding: 0 4px;
  color: #909399;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  &:hover,
  &:focus {
    color: #46B4B1;
  }
}

:deep(.answer-actions .comment-btn),
:deep(.answer-header .comment-btn) {
  gap: 4px;

  span {
    display: inline-block;
    line-height: 1;
  }
}

:deep(.answer-actions .report-btn .report-icon),
:deep(.answer-header .report-btn .report-icon),
:deep(.answer-actions .comment-btn .comment-icon),
:deep(.answer-header .comment-btn .comment-icon) {
  width: 18px;
  height: 18px;
  display: inline-block;
  flex: 0 0 auto;
  vertical-align: middle;
}

.paper-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  position: relative;
}

.compare-section {
  flex: 0 0 45%;
  padding-left: 20px;
  border-left: 1px solid #e0e0e0;
  min-width: 0;
  min-height: 80vh;
  overflow-y: auto;

  .compare-header {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 10px;

    .paper-select {
      flex: 1;
    }

    .material-icon-btn {
      flex-shrink: 0;
      width: 32px;
      height: 32px;
      padding: 0;
      border-color: #dcdfe6;
      color: #606266;

      &:hover {
        color: #46B4B1;
        border-color: #46B4B1;
      }
    }
  }

  .compare-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 300px;
    color: #999;

    p {
      margin-top: 16px;
      font-size: 14px;
    }
  }

  .paper-select {
    line-height: 25px;
    background-color: #fff;
    border-radius: 5px !important;

    :deep(.el-input__inner) {
      height: 32px !important;
      line-height: 32px !important;
      margin-top: 0 !important;
      background-color: #fff !important;
      font-size: 14px !important;
      border-radius: 5px !important;
    }
  }

  .no-permission {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 221px;
    }
  }
}

:deep(.el-tabs__item) {
  font-size: 14px;
  height: 32px;
  line-height: 32px;
  padding: 0 16px;
}

:deep(.el-tabs--card > .el-tabs__header .el-tabs__item.is-active) {
  color: #46B4B1;
}

:deep(.el-tabs--card > .el-tabs__header) {
  border-bottom: none;
}

:deep(.el-cascader) {
  width: 100%;
}

.comment-container {
  padding: 20px;
  height: calc(100% - 40px);
  display: flex;
  flex-direction: column;

  .comment-list {
    flex: 1;
    overflow-y: auto;
    margin-bottom: 20px;

    .no-comment {
      text-align: center;
      color: #999;
      padding: 20px 0;
    }

    .comment-item {
      margin-bottom: 20px;
      padding-bottom: 15px;
      border-bottom: 1px solid #eee;

      &:last-child {
        border-bottom: none;
      }

      .comment-header {
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        .username {
          margin-left: 10px;
          font-weight: 500;
          color: #333;
          font-size: 14px;
        }

        .time {
          margin-left: auto;
          font-size: 12px;
          color: #999;
        }
      }

      .comment-content {
        margin-left: 42px;
        color: #666;
        line-height: 1.5;
        font-size: 14px;
        word-break: break-all;
        white-space: pre-wrap;

        :deep(img) {
          max-width: 100%;
          height: auto;
          border-radius: 6px;
          margin: 6px 0;
          display: block;
        }
      }
    }
  }

  .comment-input {
    padding: 15px;
    background: #f9f9f9;
    border-radius: 8px;

    .el-button {
      margin-top: 10px;
      width: 100%;

      &:hover {
        background-color: #378F8C !important;
        border-color: #378F8C !important;
      }

      &:focus {
        background-color: #46B4B1 !important;
        border-color: #46B4B1 !important;
      }
    }
  }
}

:deep(.el-drawer__header) {
  margin-bottom: 0;
  padding: 8px 20px;
  border-bottom: 1px solid #eee;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  
  span {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    display: flex;
    align-items: center;
  }

  .el-drawer__close-btn {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
  }
}

:deep(.el-drawer__body) {
  padding: 0;
  overflow: hidden;
}

.delete-btn {
  color: #999;
  margin-left: 10px;
  padding: 0;

  &:hover {
    color: #f56c6c;
  }

  i {
    font-size: 16px;
  }
}

.note-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  padding-bottom: 4px;
  border-bottom: 1px dashed #eee;

  .time {
    font-size: 12px;
    color: #999;
  }

  .delete-btn {
    color: #999;
    padding: 4px;
    margin-left: 10px;

    &:hover {
      color: #f56c6c;
    }

    i {
      font-size: 16px;
    }
  }
}

.note-content {
  color: #666;
  line-height: 1.6;
  font-size: 14px;
  word-break: break-all;
  white-space: pre-wrap;
  padding: 4px 0;

  :deep(img) {
    max-width: 100%;
    height: auto;
    border-radius: 6px;
    margin: 6px 0;
    display: block;
  }
}

.user-add-answers {
  &.merged-user-add-answers {
    max-height: 480px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 10px;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ddd;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-track {
      background-color: #f5f5f5;
      border-radius: 3px;
    }
  }

  .user-add-answer-item {
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #ccc;

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }

    .answer-header {
      margin-bottom: 12px;
      padding-bottom: 8px;
      border-bottom: 1px dashed #e8e8e8;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .answer-info {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .answer-actions {
        display: flex;
        align-items: center;
        gap: 16px;

        .action-item {
          display: flex;
          align-items: center;

          .action-btn {
            padding: 0;
            height: auto;
            display: flex;
            align-items: center;
            gap: 4px;
            color: #86909c;

            &:hover {
              color: #46B4B1;
            }

            &.active {
              color: #46B4B1;
            }

            i {
              font-size: 16px;
            }

            span {
              font-size: 12px;
            }
          }
        }
      }
    }

    .answer-content {
      color: #333;
      line-height: 1.6;
      font-size: 14px;
    }
  }
}

.answer-header {
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #e8e8e8;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .answer-info {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .answer-actions {
    display: flex;
    align-items: center;
    gap: 16px;

    .action-item {
      display: flex;
      align-items: center;

      .action-btn {
        padding: 0;
        height: auto;
        display: flex;
        align-items: center;
        gap: 4px;
        color: #86909c;

        &:hover {
          color: #46B4B1;
        }

        &.active {
          color: #46B4B1;
        }

        i {
          font-size: 16px;
        }

        span {
          font-size: 12px;
        }
      }
    }
  }
}

.action-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
  vertical-align: middle;
  margin-right: 4px;
}

.action-btn {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  
  &:hover {
    background-color: rgba(70, 180, 177, 0.1);
    border-radius: 4px;
  }
  
  &.active {
    color: #46B4B1;
  }
  
  span {
    margin-left: 4px;
    font-size: 12px;
  }

  // 复制按钮特定样式
  &.copy-btn {
    i.el-icon-document-copy {
      font-size: 14px;
    }

    &:hover {
      color: #46B4B1;
      background-color: rgba(70, 180, 177, 0.1);
      border-radius: 4px;
    }
  }
}

.no-copy {
  /* 允许用户自由选择和复制文本 */
}

.material-container {
  padding: 20px;
  height: 100%;

  .materials-tabs {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    gap: 10px;
  }

  .materials-content {
    height: calc(100% - 60px);
    overflow-y: auto;
  }
}

.question-header,
.material-header {
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #e8e8e8;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .question-info,
  .material-info {
    display: flex;
    align-items: center;
    gap: 8px;

    .question-label,
    .material-label {
      font-weight: 500;
      color: #303133;
    }
  }

  .question-actions,
  .material-actions {
    display: flex;
    align-items: center;
    gap: 16px;

    .action-btn {
      padding: 0;
      height: auto;
      display: flex;
      align-items: center;
      gap: 4px;
      color: #86909c;

      &:hover {
        color: #46B4B1;
      }

      i {
        font-size: 16px;
      }
    }
  }
}

</style>
